export enum StatusAvis {
  A_VALIDER_N0 = 'A_VALIDER_N0', // Avis non renseigné - Responsable
  VALIDEES_N0 = 'VALIDEES_N0', // Avis favorable - Responsable
  A_VALIDER = 'A_VALIDER', // Avis non renseigné
  VALIDEES_N1 = 'VALIDEES_N1', // Avis favorable - Directeur
  VALIDEES_N2 = 'VALIDEES_N2', // Avis favorable - GS/RH/GPEEC
  VALIDEES_N3 = 'VALIDEES_N3', // Avis favorable - DRH
  VALIDEES_N4 = 'VALIDEES_N4', // Avis favorable - DG
  VALIDEES_N5 = 'VALIDEES_N5', // Avis favorable - DGS
  ARCHIVEES = 'ARCHIVEES', // Avis archivé - Gestionnaire RH
  REFUSEES_N0 = 'REFUSEES_N0', // Avis défavorable - Responsable
  REFUSEES_N1 = 'REFUSEES_N1', // Avis défavorable - Directeur
  REFUSEES_N2 = 'REFUSEES_N2', // Avis défavorable - GS/RH/GPEEC
  REFUSEES_N3 = 'REFUSEES_N3', // Avis défavorable - DRH
  REFUSEES_N4 = 'REFUSEES_N4', // Avis défavorable - DG
  REFUSEES_N5 = 'REFUSEES_N5' // Avis défavorable - DGS
}
